import React from "react";

interface BlockquoteProps {
  city: string;
  quote?: string;
}

const Blockquote: React.FC<BlockquoteProps> = ({
  city,
  quote = "Our goal is to provide our customers with premium cannabis products and knowledgeable guidance for all their needs in",
}) => {
  return (
    <blockquote className="bg-law-black-600/50 border-l-4 border-cannabis-green-500 p-5 my-8">
      <p className="italic text-xl">
        "{quote} {city}."
      </p>
    </blockquote>
  );
};

export default Blockquote;
